import {
  PublishParams,
  CommercialFields,
  CommercialListParams,
} from "../../view/Modules/Commercials/CommercialDataTypes";
import AxiosInstance from "../config/axiosInterceptor";
import { ContentApiRoutes } from "../../navigation/NavConstant";

export const CommercialServices = {
  getCommercials: (params: CommercialListParams) => {
    return AxiosInstance.get(ContentApiRoutes.COMMERCIALS, { params });
  },
  exportCommercials: (params: CommercialListParams) => {
    return AxiosInstance.get(ContentApiRoutes.EXPORT_COMMERCIALS, {
      params,
      responseType: "blob", // important
    }).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "commercials-export.xls");
      document.body.appendChild(link);
      link.click();
    });
  },
  createCommercial: (data: CommercialFields) =>
    AxiosInstance.post(ContentApiRoutes.CREATE_COMMERCIAL, data),
  updateCommercial: (id: number, data: CommercialFields) =>
    AxiosInstance.post(
      ContentApiRoutes.UPDATE_COMMERCIAL.replace(":id", id.toString()) +
        "?_method=PUT",
      data
    ),
  publishCommercial: (id: number, data: PublishParams) =>
    AxiosInstance.put(
      ContentApiRoutes.PUBLISH_COMMERCIAL.replace(":id", id.toString()),
      data
    ),

  publishBulkCommercial: (ids: number[], data: PublishParams) =>
    AxiosInstance.put(ContentApiRoutes.PUBLISH_BULK_COMMERCIAL, {
      ...data,
      ...{ ids: ids.toString() },
    }),

  deleteCommercial: (id: number) =>
    AxiosInstance.delete(
      ContentApiRoutes.DELETE_COMMERCIAL.replace(":id", id.toString())
    ),

  deleteBulkCommercial: (ids: number[]) => {
    let idl = { ids: ids.toString() };
    return AxiosInstance.put(ContentApiRoutes.DELETE_BULK_COMMERCIAL, idl);
  },

  viewCommercial: (id: number) => {
    return AxiosInstance.get(
      ContentApiRoutes.VIEW_COMMERCIAL.replace(":id", id.toString())
    );
  },

  searchCommercials: (commercial: string) =>
    AxiosInstance.get(
      ContentApiRoutes.COMMERCIALS + `?smart_search=${commercial}`
    ),

  deleteCommercialLogo: (id: number) =>
    AxiosInstance.put(
      ContentApiRoutes.DELETE_COMMERCIAL_LOGO.replace(":id", id.toString())
    ),
};
